import React from 'react';

type RightArrowProps = {
	className?: string;
	color?: string;
	position?: 'left' | 'right';
};

export function RightArrow({ className, color, position }: RightArrowProps) {
	const colorMap = {
		cdgr: 'var(--dark-gray)',
		cgrn: 'var(--alma-green)',
		cmgr: 'var(--client-green-500)',
		cblgr: 'var(--dark-forest)',
		cw: 'var(--white)',
		cbb: 'var(--provider-blue)',
		cgld: 'var(--gold)',
		cslm: 'var(--salmon)',
		dark: 'var(--white)',
		cbge: 'var(--cream)',
		light: 'var(--dark-gray)',
		lightGreen: 'var(--dark-forest)',
		gray: 'var(--dark-gray)',
		csgr: 'var(--soft-sage)',
		coxl: 'var(--oxley)',
		cmat: 'var(--matcha)',
		cdtl: 'var(--dark-teal)',
		cpgr: 'var(--mist)',
		csea: 'var(--seashell)',
		csbl: 'var(--soft-black)',
		crst: 'var(--rust)',
		cprp: 'var(--lavender)',
	};

	return (
		<svg
			className={className}
			xmlns='http://www.w3.org/2000/svg'
			width='14'
			height='15'
			viewBox='0 0 14 15'
			fill='none'
			style={
				position === 'left'
					? {
							left: '0',
							transform: 'rotate(180deg)',
						}
					: {}
			}
		>
			<path
				d='M7.46973 12.2256C7.17684 11.9327 7.17684 11.4579 7.46973 11.165L10.6893 7.94538L2.00003 7.9454C1.58582 7.94541 1.25003 7.60962 1.25003 7.19541C1.25003 6.78119 1.58581 6.44541 2.00003 6.4454L10.6895 6.44538L7.46973 3.22564C7.17684 2.93275 7.17684 2.45788 7.46973 2.16498C7.76262 1.87209 8.2375 1.87209 8.53039 2.16498L13.0304 6.66498C13.1087 6.74333 13.1661 6.8347 13.2026 6.93212C13.2322 7.01129 13.2489 7.09682 13.25 7.18611C13.25 7.18919 13.2501 7.19228 13.2501 7.19537C13.2501 7.3082 13.2251 7.4152 13.1805 7.51119C13.1555 7.565 13.1238 7.61646 13.0854 7.6643C13.0665 7.68785 13.0462 7.71024 13.0247 7.73134L8.53039 12.2256C8.2375 12.5185 7.76262 12.5185 7.46973 12.2256Z'
				fill={`${colorMap[color] || 'white'}`}
			/>
		</svg>
	);
}
